/**
 * AuditoriaMotivo
 * @author Simpli CLI generator
 */
import {$, ID, Resource, ResponseSerialize, TAG} from 'simpli-web-sdk'
import {
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import AuditoriaMotivoSchema from '@/schema/AuditoriaMotivo.schema'
import Responsavel from '@/model/resource/Responsavel'

export default class AuditoriaMotivo extends Resource {
  readonly $name: string = 'AuditoriaMotivo'

  readonly $endpoint: string = '/user/auditoria-motivo{/id}'

  get $schema() {
    return AuditoriaMotivoSchema(this)
  }

  get $id() {
    return this.idMotivoPk
  }
  set $id(val: ID) {
    this.idMotivoPk = val
  }
  get $tag() {
    return this.nome
  }
  set $tag(val: TAG) {
    this.nome = val
  }

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  idMotivoPk: ID = 0

  @ValidationRequired()
  @ValidationMaxLength(100)
  nome: string = ''

  @ValidationRequired()
  ativo: boolean = false

  async persistAuditoriaMotivo(spinner = 'persistAuditoriaMotivo') {
    const fetch = async () => {
      await this.validate()
      return await this.POST(`/user/auditoria-motivo`, this)
    }

    return await $.await.run(fetch, spinner)
  }

  async getAuditoriaMotivo(id: ID, spinner = 'getAuditoriaMotivo') {
    const fetch = async () => await this.GET(`/user/auditoria-motivo/${id}`)
    return await $.await.run(fetch, spinner)
  }

  async removeAuditoriaMotivo(id: number, spinner = 'removeAuditoriaMotivo') {
    const fetch = async () => await this.DELETE(`/user/auditoria-motivo/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
